import { useNavigate } from "react-router-dom";
import { Button } from "../ui/button";
import { StatusPill, EmptyState } from "./DashboardShell";
import { fmtDate, rupiah } from "../../lib/format";
import { useRoleBase } from "../../hooks/useRoleBase";
import { useAuth } from "../../context/AuthContext";

export default function OrdersTable({ orders, compact = false, emptyTitle = "Belum ada pesanan" }) {
  const navigate = useNavigate();
  const base = useRoleBase();
  const { user } = useAuth();
  if (!orders?.length) return <EmptyState title={emptyTitle} desc="Pesanan akan muncul di sini." />;
  const showUser = user.role !== "pengguna";
  const showInspector = user.role !== "inspector";
  return (
    <div className="overflow-x-auto">
      <table className="w-full text-sm min-w-[640px]" data-testid="orders-table">
        <thead>
          <tr className="text-left text-[11px] text-slate-400 font-bold border-b border-slate-100">
            <th className="pb-3 pr-3">#</th><th className="pb-3 pr-3">Jadwal</th><th className="pb-3 pr-3">Jenis Kendaraan</th>
            {showUser && <th className="pb-3 pr-3">Pengguna</th>}
            {showInspector && <th className="pb-3 pr-3">Inspector</th>}
            {!compact && <th className="pb-3 pr-3">Lokasi</th>}
            {!compact && <th className="pb-3 pr-3">Harga</th>}
            <th className="pb-3 pr-3">Status</th><th className="pb-3">Aksi</th>
          </tr>
        </thead>
        <tbody>
          {orders.map((o) => (
            <tr key={o.order_id} className="border-b border-slate-50 last:border-0 hover:bg-slate-50/60 transition-colors" data-testid={`order-row-${o.order_id}`}>
              <td className="py-3.5 pr-3 font-bold text-slate-700 text-[13px]">{o.order_id}</td>
              <td className="py-3.5 pr-3 text-slate-500 text-[13px] whitespace-nowrap">{fmtDate(o.scheduled_date)} · {o.scheduled_time}</td>
              <td className="py-3.5 pr-3 font-semibold text-slate-700 text-[13px]">
                {o.vehicle_type_label}
                {o.vehicle_info?.brand && <span className="block text-[11px] text-slate-400 font-medium">{o.vehicle_info.brand} {o.vehicle_info.model}</span>}
              </td>
              {showUser && <td className="py-3.5 pr-3 text-slate-500 text-[13px]">{o.user?.name}</td>}
              {showInspector && <td className="py-3.5 pr-3 text-slate-500 text-[13px]">{o.inspector?.name}</td>}
              {!compact && <td className="py-3.5 pr-3 text-slate-500 text-[13px]">{o.city}</td>}
              {!compact && <td className="py-3.5 pr-3 text-slate-700 font-semibold text-[13px] whitespace-nowrap">{rupiah(o.price)}</td>}
              <td className="py-3.5 pr-3"><StatusPill status={o.status} /></td>
              <td className="py-3.5">
                <Button size="sm" variant="outline" onClick={() => navigate(`${base}/pesanan/${o.order_id}`)} data-testid={`order-detail-btn-${o.order_id}`}
                  className="text-blue-600 border-blue-200 hover:bg-blue-50 text-xs font-bold rounded-lg h-8">Detail</Button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
